/* eslint-disable  no-magic-numbers */

// 生成SVG数据URI的水印背景
export const generateWatermarkSVG = (text, opacity, angle, fontSize, color) => {
    // 对文本进行编码，确保SVG有效性
    const encodedText = encodeURIComponent(text);
    color = color || `rgba(0, 0, 0, ${opacity})`;

    // 创建SVG数据URI
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Ctext x='30' y='80' font-family='Microsoft Yahei' font-size='${fontSize}' fill='${color}' opacity='${opacity}' transform='rotate(-${angle} 30,80)'%3E${encodedText}%3C/text%3E%3Ctext x='130' y='160' font-family='Microsoft Yahei' font-size='${fontSize}' fill='${color}' opacity='${opacity}' transform='rotate(-${angle} 130,160)'%3E${encodedText}%3C/text%3E%3C/svg%3E`;
};

// 创建自定义水印样式
// eslint-disable-next-line max-lines-per-function
export const createWatermark = (options) => {
    const {
        className, text = '水印', opacity = '0.3', angle = '20', fontSize = '12px', color = `rgba(0, 0, 0, ${opacity})`
    } = options;
    const elementId = 'custom-watermark-style' + options.className;
    const existingStyle = document.getElementById(elementId);
    if (existingStyle) {
        existingStyle.remove();
    }

    const svgDataURI = generateWatermarkSVG(text, opacity, angle, fontSize, color);

    const style = document.createElement('style');
    style.id = elementId;

    style.textContent = `
                .${className}::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    pointer-events: none;
                    background-repeat: repeat;
                    z-index: 100000001;
                    background-image: url("${svgDataURI}");
                }
            `;

    document.head.appendChild(style);
};
